<div class="card">
  <div class="card-body p-0">
    <app-base-list
      *ngIf="listConfig"
      [config]="listConfig"
      [data]="statuses"
      [totalRecords]="statuses.length"
      [loading]="loading"
      [paginator]="false"
      [rows]="1000" />
  </div>
</div>

<ng-template #nameTpl let-row>
  <div class="status-name-cell">
    <span class="status-dot" [ngClass]="getColorClass(row)"></span>
    <span>{{ getDisplayName(row) }}</span>
    <span *ngIf="row.isPredefined" class="predefined-pill">
      ({{ 'Settings::WorkEnvironment:StatusManagement:Predefined' | abpLocalization }})
    </span>
  </div>
</ng-template>

<ng-template #typeTpl let-row>
  {{ getTypeLocalizationKey(row) | abpLocalization }}
</ng-template>

<ng-template #actionsTpl let-row>
  <app-action-menu [items]="getMenuItems(row)"></app-action-menu>
</ng-template>
